import ReactDOM from 'react-dom';
import React from 'react';
import Header from './components/Header';
import theme from './theme';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {JssProvider} from 'react-jss';

export default props => ReactDOM.render(
    <JssProvider classNamePrefix='header-'>
        <MuiThemeProvider theme={theme}>
            <Header {...props} />
        </MuiThemeProvider>
    </JssProvider>,
    document.getElementById('base_header')
);
